// extracted by mini-css-extract-plugin
export default {"root":"EmbeddedAppUnavailable_root__GiRjx","heading":"EmbeddedAppUnavailable_heading__Y+lGQ"};